// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2534":"65bbc37509c6fdb0","2754":"f4af148453ce185f","3453":"d7b086801d3616f3","5817":"de18b4aaaf6b39b8","6084":"83b20efa0e48df8c","6725":"fb2f38f0c10bf292"}[chunkId] + ".js";
};